<template>
    <div class="Index">
        <div class="content" :style="{backgroundImage:`url(${ImageUrl})`}">
            <!-- <img src="" class="img-fluid" alt="Responsive image"> -->
            <div class="content-detail">
                <h1 data-delighter class="left" style="color: #5fe0c6;">B2C</h1>
                <h1 data-delighter class="right">图文快印解决方案（QQ/微信扫码付费打印）</h1>
                <p data-delighter class="left">为图文店、广告店店主提供电脑自助打印软件、手机自助打印软件，</p>
                <p data-delighter class="right">帮助店主拉近用户距离，助力商家轻松经营、高效增收。</p>
            </div>
        </div>
        <!-- content开始 -->
        <div class="container">
            <div class="row content-one">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 local">
                    <div class="card-deck">
                        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <img class="card-img" src="../assets/print-1.png" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title title">散客自助服务，省钱省心</h5>
                            </div>
                        </div>
                        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <img class="card-img" src="../assets/print-2.png" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title title">贴近用户，轻松拓展市场</h5>
                            </div>
                        </div>
                        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <img class="card-img" src="../assets/print-3.png" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title title">在线接单，高转化</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="card-deck card-list">
                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                            <img class="icon icon-1" src="../assets/print-4.png" alt="Card image cap">
                        </div>
                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                            <h2>散客自助服务，省钱省心</h2>
                            <p>散客自助打印、复印、扫描，无需专人服务。手机内照片、文件可直接打</p>
                            <p>印，免拷U盘，自动结算，线上支付免找零。</p>

                            <div class="row part">
                                <div class="col-4 col-md-4 area">
                                    <h1>自助</h1>
                                    <h5>自助打印文件</h5>
                                </div>
                                <div class="col-4 col-md-4 area">
                                    <h1>自动</h1>
                                    <h5>智能自助服务</h5>
                                </div>
                                <div class="col-4 col-md-4 area">
                                    <h1>便利</h1>
                                    <h5>扫码付费打印</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dark">
            <div class="container">
                <div class="row content-one">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="card-deck card-list">
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                                <h2>贴近用户，轻松拓展市场</h2>
                                <p>打印机 + 印点点自助打印软件 = 一家小型文印店，市场拓展低成本、高效率。</p>
                                <p>一台高品质彩色打印设备，即可覆盖片区内常态输出需求，形成共享文印中心。</p>

                                <div class="row part">
                                    <div class="col-4 col-md-4 area">
                                        <h1>低成本</h1>
                                        <h5>市场拓展成本低</h5>
                                    </div>
                                    <div class="col-4 col-md-4 area">
                                        <h1>高效率</h1>
                                        <h5>提高作业效率</h5>
                                    </div>
                                    <div class="col-4 col-md-4 area">
                                        <h1>共享</h1>
                                        <h5>形成文印中心</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                                <img class="icon icon-2" src="../assets/print-5.png" alt="Card image cap">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="">
            <div class="container">
                <div class="row content-one">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="card-deck card-list">
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                                <img class="icon icon-3" src="../assets/print-6.png" alt="Card image cap">
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                                <h2>在线接单，高转化</h2>
                                <p>在线接单，远程打印、送件上门，散客秒变大客户。快印平台片区内自动派</p>
                                <p>单，精准获客，订单不断。经营数据，精准分析，支持客户分级。</p>

                                <div class="row part">
                                    <div class="col-4 col-sm-4 col-md-4 .col-lg-4 col-xl-4 area">
                                        <h1>省心</h1>
                                        <h5>文档送件上门</h5>
                                    </div>
                                    <div class="col-4 col-sm-4 col-md-4 .col-lg-4 col-xl-4 area">
                                        <h1>精准</h1>
                                        <h5>精准分析获客</h5>
                                    </div>
                                    <div class="col-4 col-sm-4 col-md-4 .col-lg-4 col-xl-4 area">
                                        <h1>分级</h1>
                                        <h5>支持客户分级</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: "Index",
  data() {
    return {
        ImageUrl:require('../assets/print.png')
    };
  },
  created() {
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="stylus" scoped>
.content {
    width: 100%;
    position: relative;
    height: 535px;
    background: no-repeat center center;
    background-size: cover;
}

.local {
    margin: -64px auto 0;
}

.icon-1 {
    width: 367px;
    height: 221px;
}

.icon-2 {
    width: 434px;
    height: 271px;
}

.icon-3 {
    width: 352px;
    height: 284px;
}

.card-list {
    padding: 200px 0 158px;
}

.list-icon {
    display: flex;
    justify-content: center;
    position: relative;
}

.icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.list-item {
    text-align: left;

    h2 {
        font-size: 40px;
        line-height: 28px;
        color: #18182a;
        margin-bottom: 24px;
    }

    p {
        font-size: 16px;
        line-height: 28px;
        color: #555;
    }

    .part {
        text-align: center;
        margin-top: 100px;

        .area {
            border-right: 1px solid rgba(193, 224, 249, 0.3);

            h1 {
                font-size: 50px;
                line-height: 28px;
                color: #006ecf;
                margin: 0 0 20px 0 !important;
            }

            h5 {
                font-size: 16px;
                line-height: 28px;
                color: #006ecf;
                margin: 0 !important;
            }

            &:last-child {
                border-right: 0 !important;
            }
        }
    }
}

.dark {
    background-color: #f8fcff;
}

.content-detail {
    position: absolute;
    top: 178px;
    left: 405px;

    h1 {
        font-size: 3.2rem;
        font-weight: 100 !important;
        line-height: 2rem;
        color: #fff;
    }

    p {
        color: #fff;
    }
}

.card-img {
    width: 118px;
    height: 118px;
    margin: 0 auto;
    transition: width 1s linear 2s;
    -webkit-transition: width 1s height 1s linear 2s;
}

.title {
    font-size: 16px !important;
    font-weight: bold;
}

.clear {
    margin-left: 0 !important;
    margin-right: 0 !important;
}

// 多场景解决方案
.card-over {
    padding: 8rem 2rem !important;

    .line {
        width: 40px;
        height: 2px;
        margin: 30px auto;
        background-color: #fff;
    }

    p, button {
        opacity: 0;
    }
}

// 多场景解决方案鼠标移动效果
.clear:hover {
    position: relative;

    .card-over {
        padding: 2.25rem !important;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .mask {
        width: 300px;
        height: 480px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(24, 121, 240, 0.6);
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .line {
        display: none;
    }

    p, button {
        opacity: 1;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    h5 {
        margin-top: 10px;
    }

    p {
        margin: 20px 0 50px;
    }
}

.carouse-img {
    width: 100%;
    height: 640px;
}

.content-one {
    text-align: center;
}

.margin-top {
    margin-top: 150px;
}

.content-last {
    position: relative;
}

.content-last-img {
    width: 275px;
    height: 250px;
}

.card-kind {
    padding: 20px 0;
    border: 0 !important;
}

.card-kind:hover {
    h5 {
        color: #30bbfc;
        transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    }
}

.card-deck .card {
    margin-bottom: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/PrintSolution.vue